import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputFieldComponent } from 'src/app/components/form/input-field/input-field.component';
import { ProjectsService } from 'src/app/services/api/projects.service';
import { AlertNotificationService } from 'src/app/services/alert-notification.service';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'projects-list-of-items-to-test',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    InputFieldComponent
],
  templateUrl: './projects-list-of-items-to-test.component.html',
  styleUrl: './projects-list-of-items-to-test.component.scss'
})
export class ProjectsListOfItemsToTestComponent implements OnInit, OnChanges {
  @Input() readonly: boolean = false;
  @Input() projectId?: string;
  @Input() jurisdictionId?: string | number | null;
  items: any[] = [];
  itemsForms: { [key: number]: FormGroup } = {};
  initialQuantities: { [key: number]: number } = {};
  frozenItems: { [key: number]: boolean } = {};



  constructor(
    private fb: FormBuilder,
    private projectsService: ProjectsService,
    private alertNotificationService: AlertNotificationService
  ) { }

  ngOnInit() {
    this.loadItems(this.jurisdictionId);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['jurisdictionId'] && !changes['jurisdictionId'].firstChange && this.projectId) {
      this.loadItems(this.jurisdictionId);
    }
  }

  loadItems(jurisdictionId?: string | number | null): void {
    if (!this.projectId) {
      return;
    }

    let params = new HttpParams();
    if (jurisdictionId !== null && jurisdictionId !== undefined && jurisdictionId !== '') {
      params = params.set('jurisdictionId', `${jurisdictionId}`);
    }

    this.projectsService.listProjectsItems(Number(this.projectId), { params }).subscribe({
      next: (response) => {
        this.items = response.data.projectItems;
        this.itemsForms = {};
        this.initialQuantities = {};
        this.frozenItems = {};
        this.items.forEach((item, index) => {
          this.itemsForms[index] = this.createFormGroup(item);
          this.initialQuantities[index] = item.quantity;
          this.frozenItems[index] = item.frozen === true;
        });
      },
      error: (error) => {
        console.error('Error loading available staff:', error);
      }
    });
  }

  reloadWithJurisdiction(jurisdictionId?: string | number | null): void {
    this.loadItems(jurisdictionId);
  }


  createFormGroup(item: any): FormGroup {
    return this.fb.group({
      jurisdiction: [{ value: item.proposalItem.jurisdiction.name, disabled: true }, Validators.required],
      product: [{ value: item.proposalItem.itemProduct.code, disabled: true }, Validators.required],
      gameType: [{ value: item.proposalItem.itemType.name, disabled: true }, Validators.required],
      qty: [item.quantity, [Validators.required, Validators.min(1)]],
      createWorkingListEnabled: [item.isCreateWorkinglistEnabled]
    });
  }

  getFormControl(formGroup: FormGroup, controlName: string): FormControl {
    return formGroup.get(controlName) as FormControl;
  }

  hasQtyChanged(index: number): boolean {
    const form = this.itemsForms[index];
    const initialQty = this.initialQuantities[index];
    const currentQty = Number(form?.get('qty')?.value);

    if (initialQty === undefined || Number.isNaN(currentQty)) {
      return false;
    }

    return currentQty > Number(initialQty);
  }

  isFrozen(index: number): boolean {
    return this.frozenItems[index] === true;
  }

  isChangeOfScope(index: number): boolean {
    return this.items[index]?.proposalItem?.isChangeOfScope === true;
  }

  isCreateWorkingListDisabled(index: number): boolean {
    if (this.isFrozen(index)) {
      return true;
    }

    const form = this.itemsForms[index];

    if (!form || this.readonly) {
      return true;
    }

    if (form.invalid) {
      return true;
    }

    const isEnabled = !!form.get('createWorkingListEnabled')?.value;
    const qtyChanged = this.hasQtyChanged(index);

    return !isEnabled && !qtyChanged;
  }

  createWorkingList(index: number) {
    if (!this.projectId) {
      this.alertNotificationService.error('Project ID is required');
      return;
    }

    const item = this.items[index];
    const formValues = this.itemsForms[index].getRawValue();
    
    if (!item.projectItemId) {
      this.alertNotificationService.error('Invalid project item');
      return;
    }

    const data = {
      quantity: formValues.qty
    };

    this.projectsService.createProjectsWorkingListsFromItemsToTest(
      Number(this.projectId),
      item.projectItemId,
      data
    ).subscribe({
      next: (response) => {
        this.alertNotificationService.success('Working list created successfully');
          const savedQty = Number(formValues.qty);
          this.items[index].quantity = savedQty;
          this.itemsForms[index].patchValue({ qty: savedQty, createWorkingListEnabled: false });
          this.initialQuantities[index] = savedQty;
      },
      error: (error) => {
        this.alertNotificationService.error('Error creating working list');
        console.error('Error creating working list:', error);
      }
    });
  }
}